/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_size = /** @type {(inputs: {}) => string} */ () => {
	return `Velikost`
};

const da_size = /** @type {(inputs: {}) => string} */ () => {
	return `Størrelse`
};

const de_size = /** @type {(inputs: {}) => string} */ () => {
	return `Größe`
};

const en_size = /** @type {(inputs: {}) => string} */ () => {
	return `Size`
};

const es_size = /** @type {(inputs: {}) => string} */ () => {
	return `Talla`
};

const fr_size = /** @type {(inputs: {}) => string} */ () => {
	return `Taille`
};

const hu_size = /** @type {(inputs: {}) => string} */ () => {
	return `Méret`
};

const it_size = /** @type {(inputs: {}) => string} */ () => {
	return `Taglia`
};

const nl_size = /** @type {(inputs: {}) => string} */ () => {
	return `Maat`
};

const pl_size = /** @type {(inputs: {}) => string} */ () => {
	return `Rozmiar`
};

const pt_size = /** @type {(inputs: {}) => string} */ () => {
	return `Tamanho`
};

const sv_size = /** @type {(inputs: {}) => string} */ () => {
	return `Storlek`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const size = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.size(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("size", locale)
	if (locale === "cs") return cs_size(inputs)
	if (locale === "da") return da_size(inputs)
	if (locale === "de") return de_size(inputs)
	if (locale === "en") return en_size(inputs)
	if (locale === "es") return es_size(inputs)
	if (locale === "fr") return fr_size(inputs)
	if (locale === "hu") return hu_size(inputs)
	if (locale === "it") return it_size(inputs)
	if (locale === "nl") return nl_size(inputs)
	if (locale === "pl") return pl_size(inputs)
	if (locale === "pt") return pt_size(inputs)
	return sv_size(inputs)
};